
import archiveList from '@/containers/archive/ArchiveList.vue'
import bordereauLivraison from '@/containers/bordereauLivraison/BordereauLivraison.vue'
import bordereauLivraisonList from '@/containers/bordereauLivraison/BordereauLivraisonList.vue'
import budget from '@/containers/budget/Budget.vue'
import budgetEdit from '@/containers/budget/BudgetEdit.vue'
import budgetList from '@/containers/budget/BudgetList.vue'
import catalog from '@/containers/catalog/Catalog.vue'
import commande from '@/containers/commande/Commande.vue'
import commandeList from '@/containers/commande/CommandeList.vue'
import dashboard from '@/containers/dashboard/Dashboard.vue'
import destockage from '@/containers/destockage/Destockage.vue'
import devis from '@/containers/devis/Devis.vue'
import devisList from '@/containers/devis/DevisList.vue'
import echeancier from '@/containers/echeancier/Echeancier.vue'
import echeancierList from '@/containers/echeancier/EcheancierList.vue'
import facture from '@/containers/facture/Facture.vue'
import factureList from '@/containers/facture/FactureList.vue'
import favoriteList from '@/containers/favorite/FavoriteList.vue'
import habitList from '@/containers/habit/HabitList.vue'
import utilisateur from '@/containers/utilisateur/Utilisateur.vue'
import utilisateurEdit from '@/containers/utilisateur/UtilisateurEdit.vue'
import utilisateurList from '@/containers/utilisateur/UtilisateurList.vue'
import sav from '@/containers/sav/sav.vue'

import apiSav from '@/api/proxyWeb/sav'
import { useConfig } from '@/helpers/config';
import { goTo } from '.'

const BASE = useConfig().BASE_URI || '/'


const NAMES = {
    ARCHIVE_LIST: 'archiveList',
    ARTICLE_LIST: 'articleList',
    BORDEREAU_LIVRAISON: 'bordereauxLivraison',
    BORDEREAU_LIVRAISON_LIST: 'bordereauxLivraisonList',
    BUDGET: 'budget',
    BUDGET_EDIT: 'budgetEdit',
    BUDGET_LIST: 'budgetList',
    BUDGET_NEW: 'budgetNew',
    COMMANDE: 'commande',
    COMMANDE_LIST: 'commandeList',
    DASHBOARD: 'dashboard',
    DESTOCKAGE_LIST: 'destockageList',
    DEVIS: 'devis',
    DEVIS_LIST: 'devisList',
    ECHEANCIER: 'echeancier',
    ECHEANCIER_LIST: 'echeancierList',
    FACTURE: 'facture',
    FACTURE_LIST: 'factureList',
    FAVORITE_LIST: 'favoriteList',
    HABIT_LIST: 'habitList',
    SAV: 'sav',
    TABLE: 'table',
    UTILISATEUR: 'utilisateur',
    UTILISATEUR_EDIT: 'utilisateurEdit',
    UTILISATEUR_LIST: 'utilisateurList',
    UTILISATEUR_NEW: 'utilisateurNew',
}

export default [
    { 
        name: NAMES.ARCHIVE_LIST,
        path: '/documents/',
        component: archiveList,
        meta: {
            title: 'Vos documents',
            parent: NAMES.DASHBOARD
        }
    },
    { 
        name: NAMES.ARTICLE_LIST,
        path: '/articles/',
        component: catalog,
        meta: {
            title: 'Tarifs négociés',
            parent: NAMES.DASHBOARD
        }
    },
    { 
        name: NAMES.BORDEREAU_LIVRAISON_LIST,
        path: '/bordereaux-livraison/',
        component: bordereauLivraisonList,
        meta: {
            title: 'Vos bordereaux de livraison',
            parent: NAMES.DASHBOARD
        }
    }, {
        name: NAMES.BORDEREAU_LIVRAISON,
        path: '/bordereaux-livraison/:id/', 
        component: bordereauLivraison,
        meta: {
            title: 'Bordereau de livraison',
            parent: NAMES.BORDEREAU_LIVRAISON_LIST
        }
    }, { 
        name: NAMES.BUDGET_LIST,
        path: '/budgets/',
        component: budgetList,
        meta: {
            title: 'Vos budgets',
            parent: NAMES.DASHBOARD
        }
    }, { 
        name: NAMES.BUDGET_NEW,
        path: '/budgets/add',
        component: budgetEdit,
        meta: {
            title: 'Nouveau budget',
            parent: NAMES.BUDGET_LIST
        }
    }, {
        name: NAMES.BUDGET,
        path: '/budgets/:id/', 
        component: budget,
        meta: {
            title: 'Budget',
            parent: NAMES.BUDGET_LIST
        }
    }, { 
        name: NAMES.BUDGET_EDIT,
        path: '/budgets/:id/edit',
        component: budgetEdit,
        meta: {
            title: 'Modification',
            parent: NAMES.BUDGET
        }
    },{ 
        name: NAMES.COMMANDE_LIST,
        path: '/commandes/',
        component: commandeList,
        meta: {
            title: 'Vos commandes',
            parent: NAMES.DASHBOARD
        }
    }, {
        name: NAMES.COMMANDE,
        path: '/commandes/:id/', 
        component: commande,
        meta: {
            title: 'Commande',
            parent: NAMES.COMMANDE_LIST,
            tablePath: '/' + NAMES.TABLE
        }
    }, { 
        name: NAMES.DASHBOARD,
        path: '/',
        component: dashboard,
        meta: {
            title: 'Votre profil'
        }
    }, { 
        name: NAMES.DESTOCKAGE_LIST,
        path: '/destockage/',
        component: destockage,
        meta: {
            title: 'Déstockage',
            parent: NAMES.DASHBOARD
        }
    }, { 
        name: NAMES.DEVIS_LIST,
        path: '/devis/',
        component: devisList,
        meta: {
            title: 'Vos devis',
            parent: NAMES.DASHBOARD
        }
    }, {
        name: NAMES.DEVIS,
        path: '/devis/:id/', 
        component: devis,
        meta: {
            title: 'Devis',
            parent: NAMES.DEVIS_LIST,
            tablePath: '/' + NAMES.TABLE
        }
    }, { 
        name: NAMES.ECHEANCIER_LIST,
        path: '/echeances/',
        component: echeancierList,
        meta: {
            title: 'Vos échéances',
            parent: NAMES.DASHBOARD
        }
    }, {
        // Fix #209 ancien path pour rétrocompatibilité
        name: `${NAMES.ECHEANCIER_LIST}_deprecated`,
        path: '/echeanciers/',
        component: echeancierList,
        meta: {
            title: 'Vos échéances',
            parent: NAMES.DASHBOARD
        }
    }, {
        name: NAMES.ECHEANCIER,
        path: '/echeances/:id/', 
        component: echeancier,
        meta: {
            title: 'Echeancier',
            parent: NAMES.ECHEANCIER_LIST
        }
    }, { 
        // Fix #209 ancien path pour rétrocompatibilité
        name: `${NAMES.ECHEANCIER}_deprecated`,
        path: '/echeanciers/:id/', 
        component: echeancier,
        meta: {
            title: 'Echeancier',
            parent: NAMES.ECHEANCIER_LIST
        }
    }, { 
        name: NAMES.FACTURE_LIST,
        path: '/factures/',
        component: factureList,
        meta: {
            title: 'Vos factures',
            parent: NAMES.DASHBOARD
        }
    }, { 
        name: NAMES.FAVORITE_LIST,
        path: '/favoris/',
        component: favoriteList,
        meta: {
            title: 'Vos articles favoris',
            parent: NAMES.DASHBOARD
        }
    }, {
        name: NAMES.FACTURE,
        path: '/factures/:id/', 
        component: facture,
        meta: {
            title: 'Facture',
            parent: NAMES.FACTURE_LIST,
            tablePath: '/' + NAMES.TABLE
        }
    }, {
        name: NAMES.HABIT_LIST,
        path: '/habitudes/', 
        component: habitList,
        meta: {
            title: 'Habitudes',
            parent: NAMES.DASHBOARD
        }
    }, { 
        name: NAMES.UTILISATEUR_LIST,
        path: '/utilisateurs/',
        component: utilisateurList,
        meta: {
            title: 'Utilisateurs',
            parent: NAMES.DASHBOARD
        }
    }, {
        name: NAMES.UTILISATEUR,
        path: '/utilisateurs/:id/', 
        component: utilisateur,
        meta: {
            title: 'Utilisateur',
            parent: NAMES.UTILISATEUR_LIST
        }
    }, {  
        name: NAMES.UTILISATEUR_EDIT,
        path: '/utilisateurs/:id/edit',
        component: utilisateurEdit,
        meta: {
            title: 'Modification',
            parent: NAMES.UTILISATEUR_LIST
        }
    }, {
        name: NAMES.UTILISATEUR_NEW,
        path: '/utilisateurs/add', 
        component: utilisateurEdit,
        meta: {
            title: 'Nouvel utilisateur',
            parent: NAMES.UTILISATEUR_LIST
        }
    }, {
        name: NAMES.SAV,
        path: '/sav', 
        component: sav,
        meta: {
            title: 'SAV',
            parent: NAMES.DASHBOARD
        },
        children: [
            {
                path: ':clientCode',
                redirect: async (to) => {
                    const redirect = await apiSav.getSavUrl(to.params.clientCode)
                    goTo(redirect)
                },   
                children: [
                    {
                        path: ':addressCode',
                        redirect: async (to) => {
                            const redirect = await apiSav.getSavUrl(to.params.clientCode, to.params.addressCode)
                            goTo(redirect)
                        }                                    
                    }
                ]
            }
        ]
    },

]

export { BASE as base }
export { NAMES as names }